import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import listdata from './listdata'

const state = {
   
    data: {
        
    },    
    
        
    
    
};

export default {
  namespaced: true,
  modules: {
        listdata: listdata,
        
    },
  state,
  actions,
  getters,
  mutations,
};